import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import Products from '../../Models/Products';
import Pagination from "react-js-pagination";
import Profile from '../../Models/Profile';
import { Header } from '../Common';
import Common from "../../Models/Common";
var striptags = require('striptags');
class SellerServiceList extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            alert(this.props.t('0'))
            this.props.history.push('/login/seller');
        };
        this.state = {
            _id: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            productsList: [],
            total: [],
            profile: [],
            personal: []
        };
        // this.getTotal();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Profile.getServiceList(this.props.location.state.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ services: res.data.payload })
            }
        })
        Profile.getPortfolio(this.props.location.state.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ portfolio: res.data.payload })
            }
        })
        Profile.getProfile(this.props.location.state.id).then(res => {
            if (res.data.profile != null) {
                this.setState({ profile: res.data.profile })
                this.setState({ personal: res.data.personal })
            }
        })
    }
    componentWillMount() {
        Products.getProductList(this.props.location.state.id, 1).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }
    // getTotal() {
    //     Products.getProductList(this.props.location.state.id, 1).then(res => {
    //         console.log(res.data.total)
    //         this.setState({ total: res.data.total })
    //     })
    // }
    handlePageChange(pageNumber) {
        Products.getProductList(this.props.location.state.id, pageNumber).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload })
                this.setState({ activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage, total: res.data.total });
            }
        })
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <div className="input_name" style={{ fontSize: '13px' }}>
                                    <div>
                                        <img className="rounded-circle" alt="" src={this.state.profile.img} width="140" height="140" style={{ objectFit: 'cover' }} />
                                    </div>
                                    <div className="top_bottom_paddings">
                                        <span className="profile_name"> {this.state.personal.first_name} </span>
                                    </div>
                                    <div className="mt-5 input_name content_dertails text-left" style={{ width: '100%' }}>
                                        {this.props.t('1')}
                                    </div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "center", height: "200px" }}>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>{this.props.t('9')}</legend>
                                        <span><div className="pb-1">{this.state.profile.profession}</div></span>
                                    </fieldset>
                                    <br/>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>{this.props.t('10')}</legend>
                                        <span><div className="pb-1">{this.state.profile.description}</div></span>
                                    </fieldset>
                                    <br/>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "35%", }}>{this.props.t('7')}</legend>
                                        <span><div className="pb-1">{this.state.profile.area}</div></span>
                                    </fieldset>
                                    <br/>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>{this.props.t('11')}</legend>
                                        <span><div className="pb-1" style={{textAlign:"left"}}>{this.state.profile.address}</div></span>
                                    </fieldset>
                                </div >
                            </div > */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font text-left" style={{ width: '100%', fontSize: '20px' }}>
                                    {this.props.t('2')}
                                </div>
                                <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                    <div className="service-list-divs" style={{ borderBottom: '0px' }}>{this.props.t('3')} </div>
                                    {this.state.productsList.map((group, index) =>
                                        <div className="service-list-divs card mb-2" key={index}>
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        {/* <div style={{ backgroundColor: "#ddd", height: "20px", textAlign: "center", color: "white" }}>
                                                            <Link to={{
                                                                pathname: `/categories-details/${group.id}`,
                                                                state: { id: group.id }

                                                            }}>
                                                                {group.title}
                                                            </Link>
                                                        </div> */}
                                                        {/* {/ <div><img alt="" src={require("../../assets/images/image1.jpeg")} height="auto" width='100%' /></div> /} */}
                                                        <div style={{ height: '115px' }}><img alt="" src={Common.baseUrl + group.img} style={{ height: "100%", width: "100%", objectFit: 'cover' }} /></div>
                                                        <div style={{ backgroundColor: "#ddd", height: "20px", textAlign: "center", color: "white" }}>{parseInt(group.price)} {this.props.t('15')}</div>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "18px", borderBottom: "1px solid #bababa" }}>
                                                            <Link to={{
                                                                pathname: `/categories-details/${group.id}`,
                                                                state: { id: group.id }

                                                            }} style={{ textDecoration: 'none' }}>
                                                                {group.title}
                                                            </Link>
                                                        </div>
                                                        <div className="card-body" style={{ textAlign: "left", paddingTop: "2%", fontSize: "12px", height: "auto", padding: '0.25rem' }}>{striptags(group.trimed_long_desc)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div >
                    </div >
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6 pl-5">
                            <Pagination
                                hideNavigation
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                totalItemsCount={this.state.total}
                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                onChange={this.handlePageChange.bind(this)}
                            />
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <div className="input_name">
                                            <div>
                                                <img className="rounded-circle" alt="" src={Common.baseUrl + this.state.profile.img} width="140" height="140" style={{ objectFit: 'cover' }} />
                                            </div>
                                            <div className="top_bottom_paddings">
                                                <span className="profile_name"> {this.state.personal.first_name} </span>
                                            </div>
                                            <div className="mb-1 input_name content_dertails text-left">
                                                {this.props.t('1')}
                                        </div>
                                            {/* <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "center", height: "200px" }}> */}
                                            <div className=" row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('9')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.profession}
                                                </div>
                                            </div>
                                            <div className=" row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('10')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.description}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('7')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.area}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('11')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.address}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: '100%' }}>
                                            {this.props.t('2')}
                                    </div>
                                        <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                            <div className="service-list-divs">{this.props.t('3')} </div>
                                            {this.state.productsList.map((group, index) =>
                                                <div className="service-list-divs card" key={index}>
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                {/* <div style={{ backgroundColor: "#ddd", height: "20px", textAlign: "center", color: "white" }}>
                                                                <Link to={{
                                                                    pathname: `/categories-details/${group.id}`,
                                                                    state: { id: group.id }

                                                                }}>
                                                                    {group.title}
                                                                </Link>
                                                            </div> */}
                                                                {/* {/ <div><img alt="" src={require("../../assets/images/image1.jpeg")} height="auto" width='100%' /></div> /} */}
                                                                <div style={{ height: '115px' }}><img alt="" src={Common.baseUrl + group.img} style={{ height: "100%", width: "100%", objectFit: 'cover' }} /></div>
                                                                <div style={{ backgroundColor: "#ddd", height: "20px", textAlign: "center", color: "white" }}>{parseInt(group.price)} {this.props.t('15')}</div>
                                                            </div>
                                                            <div className="col-md-9">
                                                                <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "18px", borderBottom: "1px solid #bababa" }}>
                                                                    <Link to={{
                                                                        pathname: `/categories-details/${group.id}`,
                                                                        state: { id: group.id }

                                                                    }} style={{ textDecoration: 'none' }}>
                                                                        {group.title}
                                                                    </Link>
                                                                </div>
                                                                <div className="card-body" style={{ textAlign: "left", paddingTop: "2%", fontSize: "12px", height: "100px" }}>{striptags(group.trimed_long_desc)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6"></div>
                                <div className="col-md-6 pl-5">
                                    <Pagination
                                        hideNavigation
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.total}
                                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { SellerServiceList }


 SellerServiceList = withTranslation('src_Components_Profile_SellerServiceList')(SellerServiceList);